import { ICategoriesByProfData } from "./shared/contexts/AppContextWrapper";
import { apiCall } from "./api";


export const getSpeakUrl = async (language2_id?:string,languageCode: String="en-US",text: string="How can i help you?", ) => apiCall<ICategoriesByProfData>({ method: 'GET', url: 'common/tts',params:{language2_id,languageCode,text}})

export {}

